'use client';
import { useMemo } from 'react';
import cn from 'classnames';

import PlanCard from '@/components/common/PlanCard/PlanCard';
import Text from '@/components/common/Text/Text';

import { SubscriptionProduct } from '@/types/Subscription';

import './PlanTierGroup.style.scss';

type PlanTierGroupProps = {
  className?: string;
  plans?: SubscriptionProduct[];
  title?: string;
  titleDarkBgColor?: boolean;
};

function PlanTierGroup(props: PlanTierGroupProps) {
  const { className = '', plans, title, titleDarkBgColor } = props;

  const planCards = useMemo(() => {
    return plans?.map((plan: SubscriptionProduct) => {
      return (
        <PlanCard
          key={plan.name}
          planData={plan}
        />
      );
    });
  }, [plans]);

  return (
    <div className={cn('PlanTierGroup', className)}>
      <Text
        variant='title-xxs-500-upper'
        className={cn('PlanCardList-tier-group-title', {
          'multi-item-tier': titleDarkBgColor
        })}
      >
        {title}
      </Text>

      <div className='PlanCardList-tier-group'>{planCards}</div>
    </div>
  );
}

export default PlanTierGroup;
